<style scoped lang="scss">

</style>

<template>
    <div class="uk-grid">


        <div class="uk-width-1-1 uk-margin-large-bottom">
            <prequal-address-form
                    :states="states"
                    :counties="counties"
                    @updated="updatePropertyAddress"></prequal-address-form>
        </div>

        <div class="uk-width-1-1">
            <div v-if="propertyAddress.county_id">
                <table class="uk-table uk-table-striped">
                    <thead>
                    <tr>
                        <th>
                            HOUSEHOLD SIZE
                        </th>
                        <th class="uk-text-right">
                            MAX PRE-TAX INCOME
                        </th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-for="(incomeLimit, i) in incomeLimits" v-if="incomeLimit > 0">
                        <td>
                            {{ i }}
                        </td>
                        <td class="uk-text-right">
                            {{ incomeLimit | formatMoney }}
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p class="uk-text-center">
                <span v-if="!program.settings['prequal-income-text']"> Is your household's combined gross (before taxes and deductions) annual income for those, 18 years or older, less than or equal to the amount listed above for your eligible household size.</span>
                
                
                 <span v-if="program.settings['prequal-income-text'] != ''" v-html="program.settings['prequal-income-text']"></span>
                </p>
            </div>
        </div>


    </div>
</template>

<script>
    import PrequalAddressForm from "./PrequalAddressForm";
    export default {
        name: "IncomeQuestion",
        components: {PrequalAddressForm},
        props: ['program', 'states', 'counties'],
        data() {
            return {
                propertyAddress: { county_id: null, },
                incomeLimits: [],
            }
        },
        methods: {
            updatePropertyAddress(newValue) {
                this.propertyAddress = newValue;
                this.getIncomeLimits();
                this.$emit('addressVerified', newValue);
            },
            async getIncomeLimits() {
                let r = await axios.get('/api/lmi/'+this.propertyAddress.county_id);
                console.log(r.data);
                this.incomeLimits = [];
                let number = 1;
                _.each(r.data.low, (limit, i) => {
                    this.$set(this.incomeLimits, number, limit);
                    number++;
                })
            }
        }
    }
</script>
